import React from 'react';
import { QrCodeIcon } from '@heroicons/react/24/outline';

interface QRScannerButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const QRScannerButton: React.FC<QRScannerButtonProps> = ({ 
  onClick, 
  disabled = false,
  className = '',
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12'
  };

  const iconSizes = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6'
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`
        ${sizeClasses[size]}
        inline-flex items-center justify-center
        border border-secondary-300 
        bg-white text-secondary-700
        rounded-md
        hover:bg-primary-50 hover:border-primary-500 hover:text-primary-700
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500
        disabled:opacity-50 disabled:cursor-not-allowed
        transition-colors duration-200
        ${className}
      `}
      title="Scan QR Code"
      aria-label="Scan QR Code"
    >
      <QrCodeIcon className={iconSizes[size]} />
    </button>
  );
};

export default QRScannerButton;